import { apiSlice } from '@/store/api/apiSlice';

export interface ChartRequest {
  userId: string;              
  chartId: string;             
  chartType: 'south' | 'north';
  imageType: 'png';
}


export interface ChartResponse {
  chartUrl: string;
}

export const chartImagesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChartImage: builder.query<ChartResponse, ChartRequest>({
      query: (body) => ({
        url: 'astrology/chart',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetChartImageQuery } = chartImagesApi;
